import React, { useState } from "react";
import Layout from "../../layouts/Layout";
import {
  Backdrop,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { CustomBtn, SecondaryBtn } from "../../Components/Common/CustomBtn";
import { format } from "date-fns";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { CustomInputLabel } from "../../Components/Creators/CustomInputLabel";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack, Cancel, Delete, Edit } from "@mui/icons-material";
import { colors } from "../../theme/theme";
import axiosInstance from "../../utils/config/config";

const ExerciseView = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { id, title, start, extendedProps } = state || {};
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleDeleteEvent = async (req, res) => {
    const response = await axiosInstance.delete(
      `/exerciseevent/deleteEvent?eventId=${id}`
    );

    setOpenDeleteModal(false);

    navigate("/calendar/exerciseview");
  };
  return (
    <Layout>
      <Box
        sx={{
          "& .MuiDrawer-paper": {
            width: "75%",
            border: "1px solid #000",
            backgroundColor: "#fff",
          },
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {/* Snackbar */}
        <ErrorSnackbar
          error={errorState.error}
          handleCloseError={() => setErrorState({ error: false, message: "" })}
          errorMsg={errorState.message}
        />
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              px: 0.5,
              py: 2,
              flexDirection: "column",
            }}
          >
            <Stack direction="row">
              <IconButton
                onClick={() => {
                  navigate("/calendar");
                }}
              >
                <ArrowBack sx={{ color: "#000", opacity: 1 }} />
              </IconButton>
              <Typography
                sx={{
                  fontSize: "23px",
                  fontFamily: "Inter-SemiBold",
                  color: colors.textColor,
                }}
              >
                Exercise View
              </Typography>
            </Stack>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 2,
                width: "100%",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <SecondaryBtn
                onClick={() =>
                  navigate("/calendar/createexerciseevents", {
                    state: {
                      event: {
                        id: id,
                        mediaURL: extendedProps.mediaURL,
                        title: title,
                        startDateTime: extendedProps.start,
                        description: extendedProps.description,
                        recurrenceType: extendedProps.recurrenceType,
                        recurrenceEndDate: extendedProps.recurrenceEndDaye,
                        categories: extendedProps.exercise,
                        parentEventId: extendedProps.parentEventId,
                      },
                    },
                  })
                }
                text="Edit"
                Icon={Edit}
                noMb
                noMt
                width="100%"
              />
              <SecondaryBtn
                onClick={() => setOpenDeleteModal(true)}
                text="Delete"
                Icon={Delete}
                noMb
                noMt
                width="100%"
              />
            </Box>

            <Box sx={{ p: 2 }}>
              {extendedProps.mediaURL ? (
                extendedProps.mediaURL.match(/\.(mp4|webm|ogg|mov)$/i) ? (
                  <video
                    src={extendedProps.mediaURL}
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "contain",
                    }}
                    controls
                  />
                ) : (
                  <img
                    src={extendedProps.mediaURL}
                    alt="event preview"
                    style={{
                      width: "100%",
                      height: "350px",
                      objectFit: "contain",
                    }}
                  />
                )
              ) : (
                <img
                  src={require("../../assets/images/content-image1.png")}
                  alt="placeholder"
                  style={{
                    width: "100%",
                    height: "350px",
                    objectFit: "cover",
                  }}
                />
              )}
              <Box
                sx={{
                  pt: 2,
                  pb: 12,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack direction="row" spacing={2}>
                  <Typography
                    sx={{
                      color: colors.textColor,
                      fontSize: "18px",
                      fontFamily: "Inter-SemiBold",
                    }}
                  >
                    {title}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: colors.primary,
                      px: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: "14px",
                        fontFamily: "Inter-Medium",
                      }}
                    >
                      {format(new Date(extendedProps.start), "MMMM d, yyyy")}
                    </Typography>
                  </Box>
                </Stack>
                <Typography
                  sx={{
                    color: "#00000080",
                    fontSize: "22px",
                    fontFamily: "Inter-Regular",
                    py: 1,
                  }}
                >
                  {extendedProps.description}
                </Typography>
                {/* <Typography
                  sx={{
                    color: "#00000080",
                    fontSize: "16px",
                    fontFamily: "Inter-Light",
                  }}
                >
                  Ut enim ad minim veniam uis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat Ut enim ad
                  minim veniam uis nostrud exercitation ullamco laboris nisi ut
                  aliquip ex ea commodo consequat Ut enim ad minim veniam uis
                  nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                  commodo consequat Ut enim ad minim veniam uis nostrud
                  exercitation ullamco laboris nisi ut aliquip ex ea commodo
                  consequat Ut enim ad minim veniam uis nostrud exercitation
                  ullamco laboris nisi ut aliquip ex ea commodo consequat
                </Typography> */}

                <Grid2 container spacing={2} sx={{ mt: 2 }}>
                  {extendedProps.exercise.length > 0 &&
                    extendedProps.exercise.map((item, index) => (
                      <Grid2 item size={{ xs: 6 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: colors.primary,
                            px: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#fff",
                              fontSize: "14px",
                              fontFamily: "Inter-Medium",
                            }}
                          >
                            {item}
                          </Typography>
                        </Box>
                      </Grid2>
                    ))}
                  {/* <Typography
                      sx={{
                        color: colors.textColor,
                        fontSize: "16px",
                        fontFamily: "Inter-Regular",
                      }}
                    >
                      Level:{" "}
                      <Typography
                        component={"span"}
                        sx={{
                          color: colors.primary,
                          fontSize: "16px",
                          fontFamily: "Inter-Regular",
                        }}
                      >
                        Beginner
                      </Typography>
                    </Typography> */}
                  {/* <Grid2 item size={{ xs: 6 }}>
                    <Typography
                      sx={{
                        color: colors.textColor,
                        fontSize: "16px",
                        fontFamily: "Inter-Regular",
                      }}
                    >
                      Exercise:{" "}
                      <Typography
                        component={"span"}
                        sx={{
                          color: colors.primary,
                          fontSize: "16px",
                          fontFamily: "Inter-Regular",
                        }}
                      >
                        Cardio
                      </Typography>
                    </Typography>
                  </Grid2> */}
                  {/* <Grid2 item size={{ xs: 6 }}>
                    <Typography
                      sx={{
                        color: colors.textColor,
                        fontSize: "16px",
                        fontFamily: "Inter-Regular",
                      }}
                    >
                      Equipment:{" "}
                      <Typography
                        component={"span"}
                        sx={{
                          color: colors.primary,
                          fontSize: "16px",
                          fontFamily: "Inter-Regular",
                        }}
                      >
                        Dumbbells
                      </Typography>
                    </Typography>
                  </Grid2> */}
                  {/* <Grid2 item size={{ xs: 6 }}>
                    <Typography
                      sx={{
                        color: colors.textColor,
                        fontSize: "16px",
                        fontFamily: "Inter-Regular",
                      }}
                    >
                      Cal Burned:{" "}
                      <Typography
                        component={"span"}
                        sx={{
                          color: colors.primary,
                          fontSize: "16px",
                          fontFamily: "Inter-Regular",
                        }}
                      >
                        150 kcal
                      </Typography>
                    </Typography>
                  </Grid2> */}
                </Grid2>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this event?
            {extendedProps.parentEventId && (
              <Box
                sx={{
                  mt: 2,
                  backgroundColor: "#FFF3CD",
                  border: "1px solid #FFECB5",
                  padding: "12px",
                  borderRadius: "8px",
                }}
              >
                <Typography sx={{ color: "#856404", fontSize: "14px" }}>
                  ⚠️ This is part of a recurring series. Deleting it will not
                  affect the base event or future recurring events.
                </Typography>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryBtn
            onClick={() => setOpenDeleteModal(false)}
            text="Cancel"
            Icon={Cancel}
            noMb
            noMt
            width="30%"
          />
          <CustomBtn
            text="Delete"
            noIcon
            width={"30%"}
            onClick={handleDeleteEvent}
          />
        </DialogActions>
      </Dialog>
    </Layout>
  );
};

export default ExerciseView;
